<template>
	<glass-card
		class="lighten-card p-4"
		:class="{ locked: isBasic }"
		role="button"
		tabindex="0"
		@click="openFeature"
		@keydown.enter="openFeature"
		@keydown.space.prevent="openFeature">
		<div class="d-flex align-items-start justify-content-between gap-3">
			<div class="feature-icon" aria-hidden="true">
				<i class="bi bi-stars"></i>
			</div>
			<span class="plus-badge"><i class="bi bi-gem me-1"></i>Plus</span>
		</div>
		<h3 class="mt-3 mb-2">Lighten My Day</h3>
		<p class="mb-4">
			Keep the meals you liked. Find a few smaller changes that can lower
			the calories on any logged day.
		</p>
		<div class="d-flex align-items-center justify-content-between">
			<span class="feature-link">
				<i v-if="isBasic" class="bi bi-lock-fill me-2"></i>
				{{ isBasic ? "Unlock with Plus" : "Build a lighter day" }}
			</span>
			<i class="bi bi-arrow-right"></i>
		</div>
	</glass-card>
</template>

<script setup>
import { computed } from "vue"
import { useRouter } from "vue-router"
import GlassCard from "@/components/GlassCard.vue"
import { useUserStore } from "@/stores/user"
import * as SubscriptionHelper from "@/utils/subscriptionHelper"

const router = useRouter()
const userStore = useUserStore()
const isBasic = computed(
	() => (userStore.user?.subscription_type ?? "basic") === "basic",
)

function openFeature() {
	if (isBasic.value) {
		SubscriptionHelper.showLockedModal("Lighten My Day")
		return
	}
	router.push("/lighter-day")
}
</script>

<style scoped>
.lighten-card {
	position: relative;
	color: #f8fafc;
	cursor: pointer;
	overflow: hidden;
	transition: transform 180ms ease, border-color 180ms ease, box-shadow 180ms ease;
	background: linear-gradient(145deg, rgba(22, 101, 52, 0.3), rgba(15, 23, 42, 0.86)) !important;
}

.lighten-card::after {
	content: "";
	position: absolute;
	width: 11rem;
	height: 11rem;
	right: -4rem;
	top: -5rem;
	border-radius: 999px;
	background: rgba(74, 222, 128, 0.12);
	filter: blur(2px);
}

.lighten-card:hover,
.lighten-card:focus-visible {
	transform: translateY(-2px);
	border-color: rgba(74, 222, 128, 0.65) !important;
	box-shadow: 0 18px 45px rgba(0, 0, 0, 0.22);
	outline: none;
}

.lighten-card.locked {
	background: linear-gradient(145deg, rgba(51, 65, 85, 0.7), rgba(15, 23, 42, 0.9)) !important;
}

.feature-icon {
	display: grid;
	place-items: center;
	width: 3rem;
	height: 3rem;
	border-radius: 1rem;
	font-size: 1.35rem;
	color: #86efac;
	background: rgba(34, 197, 94, 0.15);
}

.plus-badge {
	position: relative;
	z-index: 1;
	padding: 0.35rem 0.65rem;
	border-radius: 999px;
	font-size: 0.78rem;
	font-weight: 700;
	color: #052e16;
	background: #86efac;
}

h3 {
	font-weight: 800;
	letter-spacing: -0.02em;
}

p {
	color: #cbd5e1;
}

.feature-link {
	font-weight: 700;
	color: #86efac;
}
</style>
